import type { PerformanceTier } from '@/device/deviceConfig'
import type { AmznStreamingOptions } from '@amzn/vinyl-amzn'

export interface PerformanceProfile {
    readonly uhdAllowed: boolean
    readonly reduceMotionByDefault: boolean
}

const profiles = {
    high: { uhdAllowed: true, reduceMotionByDefault: false },
    medium: { uhdAllowed: false, reduceMotionByDefault: false },
    low: { uhdAllowed: false, reduceMotionByDefault: true },
} as const satisfies Record<PerformanceTier, PerformanceProfile>

export function performanceProfile(tier: PerformanceTier): PerformanceProfile {
    return profiles[tier]
}

export function constrainStreamingOptions(
    options: AmznStreamingOptions,
    tier: PerformanceTier
): AmznStreamingOptions {
    return performanceProfile(tier).uhdAllowed || !options.uhdEnabled
        ? options
        : { ...options, uhdEnabled: false }
}
